import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const siteLayoutDefaultVariants = {}
const siteLayoutCompoundVariants = []

const siteLayoutSlotNames = [
  [
    "root",
    "SiteLayout__root"
  ],
  [
    "topbar",
    "SiteLayout__topbar"
  ],
  [
    "header",
    "SiteLayout__header"
  ],
  [
    "content",
    "SiteLayout__content"
  ],
  [
    "footer",
    "SiteLayout__footer"
  ]
]
const siteLayoutSlotFns = /* @__PURE__ */ siteLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, siteLayoutDefaultVariants, getSlotCompoundVariant(siteLayoutCompoundVariants, slotName))])

const siteLayoutFn = memo((props = {}) => {
  return Object.fromEntries(siteLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const siteLayoutVariantKeys = []
const getVariantProps = (variants) => ({ ...siteLayoutDefaultVariants, ...compact(variants) })

export const siteLayout = /* @__PURE__ */ Object.assign(siteLayoutFn, {
  __recipe__: false,
  __name__: 'siteLayout',
  raw: (props) => props,
  variantKeys: siteLayoutVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, siteLayoutVariantKeys)
  },
  getVariantProps
})